import React, { useState, useEffect, useRef, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import DetailsPageCard from '../../common/DetailsPage/DetailsPageCard';
import CustomModal from '../../../components/common/CustomModal';
import CreateSalesContract from '../CreateForm/CreateSalesContract';
import UpdateSalesContract from '../UpdateForm/UpdateSalesContract';
import MessageBox from '../../common/CustomMessageBox';
import CustomDelete from '../../common/CustomDeleteAlert';
import { useExportShipmentDetails } from './Hook/useExportShipmentDetails';
import { LIST_SALES_CONTRACTS_EXPORT, GET_PRODUCTS_LIST, GET_SUPPLIERS_LIST, DELETE_SALES_CONTRACT_EXPORT } from '../../../services/apiRoutes';
import { genericPost } from '../../../services/authServices';
import axios from 'axios';
import SalesContractView from '../ViewDetails/SalesContractView';
import CustomLoader from '../../common/CustomLoader';
import { AuthContext } from '../../../context/AuthContext';
import Shop2OutlinedIcon from '@mui/icons-material/Shop2Outlined';
import { getCurrencyList, getRoundAmount } from '../../../services/CommonServices';
import { useCompanyDateFormat } from "../../../constants/useCompanyDateFormat";


const SalesContract = ({ fetchButtonList }) => {
    const { token } = useContext(AuthContext)
    const companyDateFormat = useCompanyDateFormat();
    const [open, setOpen] = useState(true);
    const [modal, setModal] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [activeTab, setActiveTab] = React.useState('Sales Contract');
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState({ open: false, text: '', type: '' });
    const [salesContractId, setSalesContractId] = useState('');
    const [customerList, setCustomerList] = useState([]);
    const [products, setProducts] = useState([]);
    const [viewModal, setViewModal] = useState(false);
    const [newShippingId, setNewShippingId] = useState(null);
    const [currencyList, setCurrencyList] = useState([]);
    const [deleteAlert, setDeleteAlert] = useState(false)
    const [rowId, setRowId] = useState('')

    const navigate = useNavigate();
    const { exportShipmentId } = useParams();
    const { shipmentDetails, loading: shipmentLoading } = useExportShipmentDetails(exportShipmentId);


    let customerId, cifFob;
    const hasFetched = useRef(false);
    useEffect(() => {
        if (shipmentDetails) {
            customerId = shipmentDetails.customerId;

            cifFob = shipmentDetails.cifFob.cifFobName;
            getCommonData();
            fetchData();
            fetchProductsList();
            getCustomersList();
            hasFetched.current = true;
        }
    }, [shipmentDetails, updateModal, salesContractId, token, deleteAlert, modal]);

    const fetchProductsList = async () => {
        const authToken = sessionStorage.getItem('accessToken');
        const payload = {
            clientCompanyId: customerId,
        };

        try {
            const response = await axios.post(GET_PRODUCTS_LIST, payload, {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (response.status === 200 && response.data.success) {
                const productData = response.data.productsList;
                console.log(productData);
                setProducts(productData);
            } else {
                console.error('Failed to fetch products list:', response.data);
            }
        } catch (error) {
            console.error('Error fetching products list:', error);
        }
    };


    const getCustomersList = async () => {
        try {
            const payload = {
                clientCompanyId: customerId,
            };

            const response = await genericPost(GET_SUPPLIERS_LIST, payload, {
            });

            if (response.data && response.data.success && response.data.clientCompanies) {
                const customersData = response.data.clientCompanies.map((customer) => ({
                    id: customer.clientCompanyId,
                    title: customer.clientCompanyName,
                }));
                setCustomerList(customersData);
            } else {
                return [];
            }
        } catch (error) {
            console.error('Error fetching customer list:', error);
            return [];
        }
    };

    const getCommonData = async () => {
        const currencyListData = await getCurrencyList();
        setCurrencyList(currencyListData);
    }

    const fetchData = async () => {
        setLoading(true);
        try {
            const payload = {
                customerNamesId: customerId,
                shipmentId: shipmentId
            };
            const response = await genericPost(LIST_SALES_CONTRACTS_EXPORT, payload);

            if (response.data.success) {
                const salesContracts = response.data.data.map((contract, index) => {
                    const particulars = contract.particulars.map((particular) => ({
                        qty: particular.qty || 0,
                        rate: parseFloat(particular.rate) || 0,
                        amount: (particular.qty || 0) * (parseFloat(particular.rate) || 0),
                    }));

                    const totalAmount = getRoundAmount(particulars.reduce((total, { amount }) => total + amount, 0));
                    return {
                        salesContractId: contract.salesContractId || '',
                        index: (index + 1).toString().padStart(2, '0'),
                        userId: contract.userId || '',
                        companyId: contract.companyId || '',
                        customerName: contract.customer.clientCompanyName || '',
                        country: contract.customer.billingCountry.name || '',
                        reference: contract.reference || '',
                        salesContractNo: contract.salesContractNo || '',
                        date: companyDateFormat(contract?.date) || '',
                        dueDate: companyDateFormat(contract?.dueDate) || '',
                        note: contract.note || '',
                        createdAt: contract.createdAt || '',
                        updatedAt: contract.updatedAt || '',
                        particulars,
                        shipmentIdName: contract.shipmentId || '',
                        totalAmount: `${contract.currency?.currency_symbol || ''} ${totalAmount ? totalAmount.toFixed(2) : ""}`,

                    };
                });
                const { newShippingId } = response.data;
                setNewShippingId(newShippingId);
                setData(salesContracts);
            } else {
                setError('No sales contracts found');
            }
        } catch (error) {
            setError('Error fetching sales contracts');
            console.error('Error fetching sales contracts', error);
        } finally {
            setLoading(false);
        }
    };
    const handleDelete = async (salesContractId) => {
        setLoading(true);
        const authToken = sessionStorage.getItem('accessToken');

        try {
            const response = await axios.delete(DELETE_SALES_CONTRACT_EXPORT(salesContractId), {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (response.status === 200) {
                setDeleteAlert(false);
                setMessage({
                    open: true,
                    text: "deleted successfully",
                    type: "success",
                });
                fetchData();
                fetchButtonList();
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);

            if (error.response) {
                if (error.response.status === 409) {
                    setMessage({
                        open: true,
                        text: error.response.data?.error || "Cannot delete Data. Related Shipment exists.",
                        type: "error",
                    });
                } else {
                    setMessage({
                        open: true,
                        text: "An error occurred while deleting the Data.",
                        type: "error",
                    });
                }
            } else {
                console.error("Error deleting Data", error);
                setMessage({
                    open: true,
                    text: "Network error. Please try again later.",
                    type: "error",
                });
            }
        }
    };


    // Table columns
    const columns = [
        {
            accessor: 'index', label: 'SN', id: 'index', styleAccessor: {
                textAlign: 'center', maxWidth: '200px', width: "50px"
            },
        },
        {
            id: 'salesContractNo', label: 'Sales Contract', accessor: 'salesContractNo', styleAccessor: {
                textAlign: 'center',
            },
        },
        {
            id: 'date', label: 'Date', accessor: 'date', styleAccessor: {
                textAlign: 'center',
            },
        },
        {
            id: 'shipmentIdName', label: 'Shipping Id', accessor: 'shipmentIdName', styleAccessor: {
                textAlign: 'center',
            },
        },
        { id: 'customerName', label: 'Customer Name', accessor: 'customerName' },
        {
            id: 'totalAmount', label: 'Amount', accessor: 'totalAmount', styleAccessor: {
                textAlign: 'right',
            },
        },
        {
            id: 'action',
            label: 'Action',
            accessor: 'action',
            Cell: ({ row }) => (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>
                    <IconButton onClick={() => handleViewClick(row.salesContractId)} style={{ marginRight: '1px' }}>
                        <VisibilityIcon style={{ color: '#059212' }} />
                    </IconButton>
                    <IconButton onClick={() => handleUpdateClick(row.salesContractId)} style={{ marginRight: '1px' }}>
                        <ModeEditOutlineOutlinedIcon style={{ color: '#050C9C' }} />
                    </IconButton>
                    <IconButton onClick={() => handleOpenDeleteAlert(row.salesContractId)}>
                        <DeleteOutlineOutlinedIcon style={{ color: '#E4003A' }} />
                    </IconButton>
                </div>
            ),
        },
    ];

    const handleViewClick = (id) => {
        setSalesContractId(id);
        setViewModal(true);
    };

    const handleCloseView = () => {
        setViewModal(false);
        setSalesContractId('');
    };


    const handleUpdateClick = (id) => {
        setSalesContractId(id);
        setUpdateModal(true);
    };

    const handleOpenDeleteAlert = (rowId) => {
        setDeleteAlert(true)
        setRowId(rowId)
    }


    const handleOpen = () => {
        setModal(true);
    };

    const handleClose = () => {
        setModal(false);
    };

    const handleCloseUpdate = () => {
        setUpdateModal(false);
        setSalesContractId('');
    };


    if (!shipmentDetails) {
        return <p>  <CustomLoader open={shipmentLoading} /> </p>;
    }

    const companyName = shipmentDetails.customer.clientCompanyName;
    const phoneNumber = shipmentDetails.customer.mobile;
    const customerName = shipmentDetails.customerId;
    const shipmentId = shipmentDetails.shipmentId;
    const currencySymbol = shipmentDetails?.currency?.currency_symbol ?? '';
    const currencyShort = shipmentDetails?.currency?.currency ?? '';
    const currencyId = shipmentDetails?.currency?.id ?? '';
    const shipmentOrgId = shipmentDetails.exportShipmentId;

    const expProformaPrefixActivity = shipmentDetails.company.expProformaPrefixActivity ?? '';
    const expProformaPrefix = (expProformaPrefixActivity === 1)
        ? shipmentDetails.company.expProformaPrefix
        : (expProformaPrefixActivity === 0 ? '' : '');

    const expProformaSuffixActivity = shipmentDetails.company.expProformaSuffixActivity ?? '';
    const expProformaSuffix = (expProformaSuffixActivity === 1)
        ? shipmentDetails.company.expProformaSuffix
        : (expProformaSuffixActivity === 0 ? '' : '');

    const templateId = shipmentDetails?.company?.templateId ?? '1';
    // JSX Structure
    return (
        <div>
            <CustomLoader open={loading} />

            <DetailsPageCard
                Icon={Shop2OutlinedIcon}
                columns={columns}
                title="Sales Contract"
                buttonTitle="Create Sales Contract"
                handleOpen={handleOpen}
                data={data}
                loading={loading}
                error={error}
            />
            <CustomModal open={modal}  >
                <CreateSalesContract
                    fetchData={fetchData}
                    customerList={customerList}
                    productsList={products}
                    customerName={customerName}
                    shipmentId={shipmentId}
                    setMessage={setMessage}
                    newShippingId={newShippingId}
                    currencyList={currencyList}
                    currencyId={currencyId}
                    currencySymbol={currencySymbol}
                    shipmentOrgId={shipmentOrgId}
                    expProformaPrefix={expProformaPrefix}
                    expProformaSuffix={expProformaSuffix}
                    fetchButtonList={fetchButtonList}
                    handleClose={handleClose} />
            </CustomModal>

            <CustomModal open={updateModal}  >
                <UpdateSalesContract
                    fetchData={fetchData}
                    customerList={customerList}
                    productsList={products}
                    setMessage={setMessage}
                    handleClose={handleCloseUpdate}
                    salesContractId={salesContractId}
                    currencyList={currencyList}
                    expProformaPrefix={expProformaPrefix}
                    expProformaSuffix={expProformaSuffix}
                />
            </CustomModal>

            <CustomModal open={viewModal} handleClose={handleCloseView}>
                <SalesContractView
                    fetchData={fetchData}
                    customerList={customerList}
                    productsList={products}
                    setMessage={setMessage}
                    handleClose={handleCloseView}
                    salesContractId={salesContractId}
                    expProformaPrefix={expProformaPrefix}
                    expProformaSuffix={expProformaSuffix}
                    templateId={templateId}
                    shipmentOrgId={shipmentOrgId}
                />
            </CustomModal>

            <MessageBox
                open={message.open}
                onClose={() => setMessage({ ...message, open: false })}
                message={message.text}
                handleClose={() => setMessage({ ...message, open: false })}
                type={message.type}
            />
            <CustomDelete
                handleDelete={handleDelete}
                open={deleteAlert}
                rowId={rowId}
                handleClose={() => setDeleteAlert(false)}
            />
        </div>
    );
};

export default SalesContract;
